export const environment = {
  production: true,
  endpoint: 'https://cenutre.vercel.app/api',
  secure: 'awmxGyRg7KEGViAjXm3JBC9po49lc0r3452',
};
